import React, { useState } from 'react';

const NewsLetter = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <>
      <div className=" flex h-96 flex-col items-center justify-center rounded-[24px] bg-gradient-to-br from-[#FFF] via-[#F7F7F7] to-[#F7F7F7] p-4 md:p-[52px] md:pt-[32px]">
        <div className="fredoka mb-6 text-center text-[18px] font-medium leading-[24px] tracking-[-0.18px] text-[#044047]">
          Subscribe to our Newsletter for our latest updates
        </div>
        <div className="flex h-[86px] w-[86px] items-center justify-center rounded-full bg-white">
          <img src="/images/icons/Envelope.svg" alt="Envelop" />
        </div>

        <div className="w-full">
          <div className="mt-[30px] rounded-2xl border-2 bg-white">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="m-[15px]"
              placeholder="Enter your Email Address"
            />
          </div>
          <div className="mt-4 flex items-center  justify-center rounded-2xl border-2 border-[#66CDCC] px-[52px] text-[#66CDCC]">
            <button
              type="submit"
              onClick={handleSubmit}
              className="m-[10px] flex text-base font-bold text-[#66CDCC]"
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsLetter;
